module.exports = __webpack_public_path__ + "img/how-we-work.48ac220b.jpg";